/*
 *
 * Home Actions
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 26-Oct-2022
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_PERIOD_LABELS: '@@Home/set_period_labels',
	DO_SET_CURRENCY: '@@Home/set_currency',
	DO_SET_TIMER: '@@Home/set_timer',
	// @generator action:route:type
	...createRequestTypes('@@Home', 'RETRIEVE_SALES'),
	...createRequestTypes('@@Home', 'RETRIEVE_SALES_CARD'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Richiede le vendite
 * @name retrieveSales
 * @param {array} currencies - Array di valute
 * @return {object} - L'oggetto azione
 */
export const retrieveSales = new MakeRequest('Home', 'retrieve_sales');

/** @action request
 * * Richiede le vendite
 * @name retrieveSalesCard
 * @return {object} - L'oggetto azione
 */
export const retrieveSalesCard = new MakeRequest('Home', 'retrieve_sales_card');

/** @action
 * * Imposta il timer
 * @name doSetTimer
 * @return {object} - L'oggetto payload
 */
export const doSetTimer = (payload) => createAction(actionTypes.DO_SET_TIMER, { payload });

/** @action
 * * Imposta la valuta
 * @name doSetCurrency
 * @return {object} - L'oggetto payload
 */
export const doSetCurrency = (payload) => createAction(actionTypes.DO_SET_CURRENCY, { payload });

/** @action
 * * Imposta le etichette del periodo
 * @name doSetPeriodLabels
 * @return {object} - L'oggetto payload
 */
export const doSetPeriodLabels = (payload) => createAction(actionTypes.DO_SET_PERIOD_LABELS, { payload });
